// extracted by mini-css-extract-plugin
export var container = "ResearchAndDevelopmentCombinationsDiagram-module--container--3nbsO";
export var definition = "ResearchAndDevelopmentCombinationsDiagram-module--definition--90BeI";
export var descriptionContainer = "ResearchAndDevelopmentCombinationsDiagram-module--description-container--5S2QJ";
export var description = "ResearchAndDevelopmentCombinationsDiagram-module--description--+cZyg";
export var heading = "ResearchAndDevelopmentCombinationsDiagram-module--heading--biISX";